(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ql-accordion"] && !Shopify.designMode) return;
  try {
    
var QAccordion = class extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    let items = this.querySelectorAll(".acc-item")
    items.forEach(item => {
      item.addEventListener("mouseenter", () => {
        items.forEach(ite => {
          ite.classList.remove('act')
        })
        item.classList.add("act")
      })
    })
    let id = this.getAttribute("section-id")
    let className = '.swiper-' + id
    let className1 = '.pagination-' + id
    const swiper = new Swiper(className, {
      loop: true,
      spaceBetween: 20,
      slidesPerView: 'auto',
      pagination: {
        el: className1
      }
    })
  }
};
if (!window.customElements.get("q-accordion")) {
  window.customElements.define("q-accordion", QAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-folding-panel-with-image"] && !Shopify.designMode) return;
  try {
    
class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let sectionId = this.getAttribute("section-id")
    let className = `.swiper-${sectionId}`
    const swiper = new Swiper(className, {
      loop: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.qvs-next',
        prevEl: '.qvs-prev',
      }
    });

    let sliders = this.querySelectorAll('.swiper-slide');
    let oSwiper = this.querySelector('.qvs-swiper');   
    let oItems = this.querySelectorAll('.qvs-slider-a');
    let oVideos = this.querySelectorAll('.qvs-big-video');
    let oMask = this.querySelector('.qvs-mask');
    let oFull = this.querySelectorAll('.qvs-full-box');
    let oClose = this.querySelector('.qvs-mask-close');
    let index = 0
    oItems.forEach((item, i) => {
      item.addEventListener("click", () => {
        let url = item.getAttribute("data-url");
        if (url) {
          index = i
          oMask.setAttribute("show", "1")
          oFull.forEach(v => {
            v.setAttribute("show", "")
          })
          oFull[i].setAttribute("show", "1")
          console.log(oFull[i])
          oVideos[i].play()
        }
      })
    })
    oClose.addEventListener("click", () => {
      oMask.setAttribute("show", "")
      oVideos[index].pause()
    })
  }
}
if (!customElements.get('q-video-slider')) {
  customElements.define('q-video-slider', VideoSlider);
}

  } catch(e) { console.error(e); }
})();
})();
